import { ICustomRouterConfig } from "@/routers";

type ValueOf<T> = T[keyof T];

export enum EActionType {
  LOADING = "globle/LOADING",
  SET_ROUTES = "globle/SET_ROUTES",
  USERINFO = "globle/USERINFO",
  NO_AUTHORITY = "globle/NO_AUTHORITY",
}

export interface IActionType {
  type: ValueOf<EActionType>;
  loading?: boolean;
  routes?: ICustomRouterConfig[];
  userInfo: UserInfoType;
  noAuthority: boolean;
}

export enum ETeacherType {
  ADMIN = 3, // 管理员
  MAIN = 1, // 主讲老师
  MINOR = 2, // 辅导老师
}

export type TTeacherType = ValueOf<typeof ETeacherType> | null;
export type UserInfo = {
  account: string;
  email: string;
  name: string;
  workcode: string;
  teacher_id: number;
  teacher_type: TTeacherType;
};

export interface IGlobleState {
  loading: boolean;
  userInfo: UserInfo;
  routes: ICustomRouterConfig[];
  noAuthority: boolean;
}

export interface UserInfoType {
  account: string;
  email: string;
  name: string;
  workcode: string;
  teacher_id: number | null;
  teacher_type: TTeacherType;
}
